module.exports = __webpack_public_path__ + "img/zodiac-hustle-start.66a409c3.jpg";